import React, { createContext, useState, useContext, ReactNode } from 'react';
import useThemeMode from '../hooks/useThemeMode';
import { Theme, darkTheme, lightTheme } from '../styles/Theme';


// Define the type for the theme
//type Theme = 'light' | 'dark';

// Define the context
interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// Create a custom hook to consume the theme context
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { theme, themeToggler } = useThemeMode({ light: lightTheme, dark: darkTheme });

  const toggleTheme = () => {
    themeToggler();
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};


